import { locales, langLiteralType } from "./locales";

export default function moneyFormat(amount: number, langStr: langLiteralType | string, currency: string) {
    return new Intl.NumberFormat(locales[langStr], {
        style: "currency",
        currency: currency,
        currencyDisplay: currency ? "code" : null,
        useGrouping: true,
    }).format(amount);
}